// Calendar dates as 'YYYY-MM-DD' strings. They sort lexically, so comparisons use plain < and >.

import type { DateStr, Span } from './schema.ts';

/** First day the time slider can show. */
export const EPOCH_START: DateStr = '2000-01-01';

const DAY_MS = 86_400_000;

export function toDate(d: DateStr): Date {
  return new Date(`${d}T00:00:00Z`);
}

export function fromDate(d: Date): DateStr {
  return d.toISOString().slice(0, 10);
}

export function addDays(d: DateStr, days: number): DateStr {
  return fromDate(new Date(toDate(d).getTime() + days * DAY_MS));
}

export function daysBetween(a: DateStr, b: DateStr): number {
  return Math.round((toDate(b).getTime() - toDate(a).getTime()) / DAY_MS);
}

export function yearOf(d: DateStr): number {
  return Number(d.slice(0, 4));
}

/** True when `d` falls inside the span (from inclusive, to exclusive; open-ended if to is null). */
export function inSpan(span: Pick<Span, 'from' | 'to'>, d: DateStr): boolean {
  return span.from <= d && (span.to === null || d < span.to);
}
